// extracted by mini-css-extract-plugin
module.exports = {"header":"Relationship_header__R81P-","name":"Relationship_name__2vcxw","underline":"Relationship_underline__2X7qE"};